import { FC } from 'react';

type GapBarProps = {
  score: number;
  winnersTarget: number;
  youLabel: string;
  winnersLabel: string;
  caption?: string;
};

/**
 * The verdict gap bar (spec 6.4): amber fill to the user's score, hatched
 * red zone spanning the gap, green winners marker, real numbers labelled.
 */
const GapBar: FC<GapBarProps> = ({
  score,
  winnersTarget,
  youLabel,
  winnersLabel,
  caption
}) => {
  const clampedScore = Math.max(0, Math.min(100, score));
  const clampedTarget = Math.max(clampedScore, Math.min(100, winnersTarget));

  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <p className="font-heading text-sm font-bold text-primary-600">
          {youLabel}: {clampedScore}%
        </p>
        <p className="font-heading text-sm font-bold text-greenfriday">
          {winnersLabel}: {clampedTarget}%
        </p>
      </div>
      <div className="relative">
        <div className="h-3 overflow-hidden rounded-full bg-neutral-200">
          {/* Hatched gap zone */}
          <div
            className="absolute top-0 h-3"
            style={{
              left: `${clampedScore}%`,
              width: `${clampedTarget - clampedScore}%`,
              background:
                'repeating-linear-gradient(135deg, #009DE5 0, #009DE5 4px, #75CAF1 4px, #75CAF1 8px)'
            }}
          />
          {/* Primary-blue fill to the user's score */}
          <div
            className="absolute top-0 h-3 rounded-l-full bg-primary-500"
            style={{ width: `${clampedScore}%` }}
          />
        </div>
        {/* Winners marker */}
        <span
          className="absolute -top-1 h-5 w-0.5 -translate-x-1/2 rounded bg-greenfriday"
          style={{ left: `${clampedTarget}%` }}
        />
      </div>
      {caption && (
        <p className="mt-3 font-heading text-sm font-bold text-danger-600">
          {caption}
        </p>
      )}
    </div>
  );
};

export default GapBar;
